/*
import "./VisJet/comp"



import "./VisJet/VisjetAnimTest"
import "./VisJet/VisjetPhotoTrans"
import "./VisJet/VisjetPhotoTransAct3"
import "./VisJet/VisjetImageSequence"
import '../PhotoEffects/PhotoEffects';

import '../doritos/doritosMockup'

import "./xfinity/xfinityMockup"

import "./EY/comp"
import '../EY/parallaxDemo'
import '../EY/parallaxPages/belonging'
import '../EY/parallaxPages/programmes'
import '../EY/parallaxPages/whyey'
import '../EY/parallaxPages/technology'
import '../EY/parallaxPages/locations'
import "./ParallaxSections/ParallaxObjects"
import "./ParallaxSections/ParallaxSectionsContainer"

*/

// import '../LeapTest'
// import "./LeapHand"

// import '../Roche/SusvimoTester'
// import '../Roche/ImageZoomTest'

// 8th Wall

// import "./XR8/XR8AbstractTarget";

import Object3DManager from "@three-extra/asset/Object3DManager";

import shaderUtils from "@three-extra/util/ShaderUtils";

import EasingValue2 from "@data-trans/EasingValue2";

import isIOS from "@three-extra/profiling/isIOS";
import typeManager from "@cloud/TypeManager";

import EasingValue from "@data-trans/EasingValue";

import forceWebGL1 from "@three-extra/util/forceWebGL1";
import { createDerivedMaterial } from "troika-three-utils";
import { Text } from "troika-three-text";

import cloneDeep from "lodash/cloneDeep";
import EasingFunctions from "@data-trans/EasingFunctions";
import EasingValueLoop from "@data-trans/EasingValueLoop";

import Ctrl from "@three-extra/ctrl/Ctrl";

import inputManager from "@input/InputManager";
import factoryMat from "@three-extra/asset/MaterialManager";
import factoryGeom from "@three-extra/asset/GeometryManager";
import { Inputs, Outputs } from "@rt/InputsOutputs";

import objectManager from "@cloud/ObjectManager";

import { debounce } from "lodash/debounce";

import * as cloud from "../cloud";
import * as three from "../three-extra";

window.Object3DManager = Object3DManager;

window.EasingValue2 = EasingValue2;

window.isIOS = isIOS;
window.typeManager = typeManager;

window.EasingValue = EasingValue;
window.forceWebGL1 = forceWebGL1;
window.shaderUtils = shaderUtils;
window.createDerivedMaterial = createDerivedMaterial;
window.Text = Text;

window.Ctrl = Ctrl;

window.cloneDeep = cloneDeep;
window.EasingFunctions = EasingFunctions;
window.EasingValue = EasingValue;
window.EasingValueLoop = EasingValueLoop;
window.inputManager = inputManager;
window.objectManager = objectManager;

window.objectManager = objectManager;

window.factoryGeom = factoryGeom;
window.factoryMat = factoryMat;
window.materialManager = factoryMat;
window.Inputs = Inputs;

window.cloudClient = cloud.cloudClient;

window.VisComp = three.VisComp;
window.debounce = debounce;
